'use client';

import { useEffect } from 'react';
import { trackShortLinkVisitPostHogClient } from '@/lib/posthog-client';

interface ShortLinkRedirectProps {
  shortCode: string;
  deviceType: string;
  redirectUrl: string;
  userAgent: string;
  ipAddress: string;
  webLink: string;
  mobileWebLink: string | null;
  androidLink: string | null;
  iosLink: string | null;
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  utmTerm: string;
  utmContent: string;
  userId: string;
  appId: string;
}

export default function ShortLinkRedirect({
  shortCode,
  deviceType,
  redirectUrl,
  userAgent,
  ipAddress,
  webLink,
  mobileWebLink,
  androidLink,
  iosLink,
  utmSource,
  utmMedium,
  utmCampaign,
  utmTerm,
  utmContent,
  userId,
  appId,
}: ShortLinkRedirectProps) {

  useEffect(() => {
    const handleTrackingAndRedirect = async () => {
      try {
        // Track PostHog event on client side
        await trackShortLinkVisitPostHogClient(
          shortCode,
          deviceType,
          redirectUrl,
          userAgent,
          ipAddress,
          webLink,
          mobileWebLink,
          androidLink,
          iosLink,
          utmSource,
          utmMedium,
          utmCampaign,
          utmTerm,
          utmContent,
          userId,
          appId
        );
        
        // Redirect after tracking is complete
        window.location.href = redirectUrl;
        
      } catch (error) {
        // Still redirect even if tracking fails
        window.location.href = redirectUrl;
      }
    };

    // Execute tracking and redirect
    handleTrackingAndRedirect();
  }, [
    shortCode,
    deviceType,
    redirectUrl,
    userAgent,
    ipAddress,
    webLink,
    mobileWebLink,
    androidLink,
    iosLink,
    utmSource,
    utmMedium,
    utmCampaign,
    utmTerm,
    utmContent,
    userId,
    appId,
  ]);

  // Show loading state while tracking and redirecting
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        <div className="mb-8">
          <div className="mx-auto h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-purple-600" />
        </div>
        <div className="mb-8">
          <h1 className="mb-4 text-2xl font-bold text-gray-800">
            Đang chuyển hướng...
          </h1>
          <p className="leading-relaxed font-light text-gray-600">
            Vui lòng chờ trong giây lát
          </p>
        </div>
      </div>
    </div>
  );
}
